// extracted by mini-css-extract-plugin
module.exports = {"container":"Fa","overlay":"Ga","headingSection":"Ha","close":"Ia","copy":"Ja","m-heart-activate":"Ka","bottomSection":"La","disabled":"Ma","m-heart-pulse":"Na"};